// Uclean-Admin-Dashboard/src/mocks/promo/index.js
// Single export point for the promo MSW worker.
// Each per-resource handlers file matches a docs/admin-handover.md §2.1 sub-section.

import { promotionsHandlers } from './promotions/handlers';
import { discountRulesHandlers } from './discountRules/handlers';
import { promoCodesHandlers } from './promoCodes/handlers';
import { promotionGroupsHandlers } from './promotionGroups/handlers';
import { reactivationAuditHandlers } from './reactivationAudit/handlers';

export const promoHandlers = [
  ...promotionsHandlers,
  ...discountRulesHandlers,
  ...promoCodesHandlers,
  ...promotionGroupsHandlers,
  ...reactivationAuditHandlers,
];
